module.exports = __webpack_public_path__ + "img/icon_mid_pt_shadow.ebe77686.png";